import {getColorStyle} from '@/utilities/color-style-map';
import classNames from 'classnames';
import {ComponentChildren} from 'preact';

export default PackOptionButton;

function PackOptionButton({
  badge = '',
  badgeColor,
  bottom,
  color = 'primary-blue',
  dataTestId = '',
  isSelected = false,
  middle = null,
  onClick,
  top = null,
}: PackOptionButtonProps) {
  const colorStyle = getColorStyle(color);
  const badgeColorStyle = getColorStyle(badgeColor ?? 'primary-blue');

  return (
    <button
      data-testid={dataTestId}
      className={classNames(
        'fast-transition relative flex h-max w-full flex-col items-center justify-center rounded-md border-2 py-3 leading-normal',
        {
          [`${colorStyle.border} ${colorStyle.background} text-bright-white`]:
            isSelected,
          'bg-bright-white text-neutral-dark-gray': !isSelected,
          [badgeColorStyle.border ?? '']: !isSelected && badge,
        }
      )}
      onClick={onClick}
    >
      {badge && (
        <span
          className={classNames(
            badgeColorStyle.background,
            'absolute left-1/2 top-0 z-10 w-max -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded px-1 py-0.5 text-[7px] font-semibold uppercase tracking-[0.5px] text-bright-white'
          )}
        >
          {badge}
        </span>
      )}{' '}
      <span
        className={classNames('text-2xs font-medium', {
          [badgeColor ? badgeColorStyle.text : 'text-neutral-dark-grey']:
            !isSelected,
        })}
      >
        {top}
      </span>
      {middle && <h5>{middle}</h5>}
      <span className="text-2xs font-medium">{bottom}</span>
    </button>
  );
}

export type PackOptionButtonProps = {
  badge?: string;
  badgeColor?: string;
  bottom?: ComponentChildren;
  color?: string;
  dataTestId?: string;
  isSelected?: boolean;
  middle?: ComponentChildren;
  onClick?: () => void;
  top?: ComponentChildren;
};
